import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllRackCellMapsResponseModel, RackCellMapDto, RackCellMapResponseModel } from '@gtpl/shared-models/masters';
import { RackCellMap } from './rack-cell-mapping.entity';
import { RackCellMapAdapter } from './dto/rack-cell-mapping.adapter';
import { RackCellMapDTO } from './dto/rack-cell-mapping.dto';
import { RackCellMapRequest } from './dto/rack-cell-mapping.request';

@Injectable()
export class RackCellMappingService {

    constructor(
        @InjectRepository(RackCellMap) private rackCellMapRepository: Repository<RackCellMap>,
        private rackCellMapAdapter: RackCellMapAdapter,
      ) { }
      async getRackCellMapWithoutRelations(rackCellMapId: number): Promise<RackCellMap> {
        //  console.log(employeeId);
            const response = await this.rackCellMapRepository.findOne({
            where: {rackCellMapId: Raw(alias => `rack_cell_map_id = '${rackCellMapId}'`)},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

      async createRackCellMap(rackCellMapDto:RackCellMapDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RackCellMapResponseModel> {
        try {
        
        if (!isUpdate) {
            const rackCellMapEntity = await this.getRackCellMapWithoutRelations(rackCellMapDto.rackCellMapId);
          if (rackCellMapEntity) {
            throw new ErrorResponse(11104, 'rackCellMap already exists');
          }
        }
        const rackCellMapEntity: RackCellMap = this.rackCellMapAdapter.convertDtoToEntity(rackCellMapDto,isUpdate);
        const savedrackCellMapEntity: RackCellMap = await this.rackCellMapRepository.save(rackCellMapEntity);
        const savedRackCellMapDTO: RackCellMapDTO = this.rackCellMapAdapter.convertEntityToDto(savedrackCellMapEntity);
       
         if (savedrackCellMapEntity) {
          const response = new RackCellMapResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'RackCellMap Updated Successfully':'RackCellMap Created Successfully',savedRackCellMapDTO);
          return response;
        } else {
          throw new ErrorResponse(11106,'RackCellMap saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        throw error;
      }
    }

    async getAllRackCellMaps(): Promise<AllRackCellMapsResponseModel> { 
        try {
            const rackCellMapDto: RackCellMapDto[] = [];
            // retrieves all plants
            const rackCellMapEntities: RackCellMap[] = await this.rackCellMapRepository.find({
                order: { createdAt: "DESC" },
            });
            if (rackCellMapEntities.length>0) {
                rackCellMapEntities.forEach(rackCellMapEntity => {
                const convertedCellDto: RackCellMapDto = this.rackCellMapAdapter.convertEntityToDto(rackCellMapEntity);
                rackCellMapDto.push(convertedCellDto);
                });
                const response = new AllRackCellMapsResponseModel(true, 11208, "RackCellMaps retrieved successfully", rackCellMapDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getAllActiveRackCellMaps(): Promise<AllRackCellMapsResponseModel> {
        // const page: number = 1;
        try {
            const rackCellMapDto: RackCellMapDTO[] = [];
            //retrieves all companies
            const RackCellMapsEntities: RackCellMap[] = await this.rackCellMapRepository.find({ order: { 'rackId': 'ASC' },
           });
         console.log(RackCellMapsEntities)
            if (RackCellMapsEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                RackCellMapsEntities.forEach(rackCellMapEntity => {
                    const convertedrackCellMapDto: RackCellMapDTO = this.rackCellMapAdapter.convertEntityToDto(
                      rackCellMapEntity
                    );
                    rackCellMapDto.push(convertedrackCellMapDto);
                });
                const response = new AllRackCellMapsResponseModel(true, 11108, "RackCellMaps retrieved successfully", rackCellMapDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); rackCellMapDto
            }
        } catch (err) {
            throw err;
        }
    }

    async activateOrDeactivaterackCellMap(rackCellMapReq: RackCellMapRequest): Promise<RackCellMapResponseModel> {
        try {
            const rackCellMapExists = await this.getRackCellMapById(rackCellMapReq.rackCellMapId);
            if (rackCellMapExists) {
                if (rackCellMapReq.versionFlag !== rackCellMapExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current cell information.Refresh and try again');
                } else {
                    
                        const rackCellMapStatus =  await this.rackCellMapRepository.update(
                            { rackCellMapId: rackCellMapReq.rackCellMapId },
                            { isActive: rackCellMapReq.isActive,updatedUser: rackCellMapReq.updatedUser });
                       
                        if (rackCellMapExists.isActive) {
                            if (rackCellMapStatus.affected) {
                                const rackCellMapResponse: RackCellMapResponseModel = new RackCellMapResponseModel(true, 10115, 'RackCellMap is de-activated successfully');
                                return rackCellMapResponse;
                            } else {
                                throw new ErrorResponse(10111, 'rackCellMap is already deactivated');
                            }
                        } else {
                            if (rackCellMapStatus.affected) {
                                const rackCellMapResponse: RackCellMapResponseModel = new RackCellMapResponseModel(true, 10114, 'RackCellMap is activated successfully');
                                return rackCellMapResponse;
                            } else {
                                throw new ErrorResponse(10112, 'RackCellMap is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getRackCellMapById(rackCellMapId: number): Promise<RackCellMap> {
        //  console.log(employeeId);
            const Response = await this.rackCellMapRepository.findOne({
            where: {rackCellMapId: rackCellMapId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}
